import React, { useState } from 'react';
import LottieAvatar from './LottieAvatar';
import GLBViewer from './GLBViewer'; // <- new import

const AvatarTestPage = () => {
  const [text, setText] = useState('Hello, how can I help you today?');
  const [isTalking, setIsTalking] = useState(false);

  const speakText = async () => {
    if (!text.trim()) return;

    setIsTalking(true);

    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/conversations/tts-preview`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ text }),
    });

    const blob = await res.blob();
    const audioUrl = URL.createObjectURL(blob);
    const audio = new Audio(audioUrl);

    audio.play();
    audio.onended = () => setIsTalking(false);
  };

  return (
    <div className="p-6 space-y-6">
      <div className="max-w-md mx-auto space-y-4">
        <h2 className="text-xl font-semibold">🎭 Lottie Avatar Test</h2>

        <input
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="w-full border px-3 py-2 rounded"
          placeholder="Type something for the avatar to say"
        />

        <button
          onClick={speakText}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Speak
        </button>
      </div>

      <div className="flex justify-center">
        <LottieAvatar play={isTalking} />
      </div>

      <div className="flex justify-center mt-10">
        <GLBViewer modelUrl="https://models.readyplayer.me/6882d68df09af2f182702759.glb" />
      </div>
    </div>
  );
};

export default AvatarTestPage;
